/** Escape a string for safe use inside an HTML attribute (double-quoted). */
export const escapeAttr = (v: string) =>
  v.replace(/&/g, "&amp;").replace(/"/g, "&quot;");
